import { ControlLabel, FormGroup } from 'react-bootstrap';
import React from 'react';
import { Form } from 'react-final-form';
import EmployeesAutocomplete from '../employees-autocomplete/EmployeesAutocomplete.jsx';
import EmployeeRow from './EmployeeRow.jsx';
import { TriangleBlueIcon } from '../icons/TriangleBlueIcon.jsx';
import EmployeeForm from '../employees/EmployeeFormModal/EmployeeForm.jsx';
import AuthorizedAction from '../AuthorizedAction.js';

const ManageParticipantsForm = ({
  handleSelect,
  additionalSearchParams,
  formState,
  ungroupedEmployees,
  onLoadMore,
  showLoadMore,
  pending,
  onParentSelect,
  onGroupSelect,
  onAddEmployeeSubmit,
  newEmployeeEntities,
  showEmployeeForm,
  setShowEmployeeForm,
  disabledGroupIds,
  errors,
}) => {
  return showEmployeeForm ? (
    <div
      className="
      component
      component-border-bottom
      component-border-top
      component-border-left
      component-border-right m-b-24"
    >
      <Form
        onSubmit={onAddEmployeeSubmit}
        onManualSubmit={onAddEmployeeSubmit}
        onManualCancel={setShowEmployeeForm}
        onParentSelect={onParentSelect}
        onGroupSelect={onGroupSelect}
        manuallyGeneratedError={errors}
        selectedEntities={newEmployeeEntities}
        disabledGroupIds={disabledGroupIds}
        isGroupSelectDisabled={true}
        isInitiative={false}
        component={EmployeeForm}
      />
    </div>
  ) : (
    <React.Fragment>
      <FormGroup className="m-b-16">
        <ControlLabel>Select or Add Impacted People</ControlLabel>
        <EmployeesAutocomplete
          handleSelect={handleSelect}
          additionalSearchParams={additionalSearchParams}
          isItemActive={(id) => formState.includes(id)}
        />
      </FormGroup>

      <div className="flex flex-justify">
        <ControlLabel>
          Selected Employee(s)
          <strong className="bordered bordered-xs text-muted m-l-8">
            Total:&nbsp;
            <span className="text-info-brand count">{formState.length}</span>
          </strong>
        </ControlLabel>

        {!showEmployeeForm ? (
          <AuthorizedAction action="create" subject="employee">
            <button
              type="button"
              className="btn-link"
              onClick={() => setShowEmployeeForm(!showEmployeeForm)}
            >
              {' '}
              + Add People
            </button>
          </AuthorizedAction>
        ) : null}
      </div>

      {pending ? <h5 className="m-b-8">Loading...</h5> : null}

      {Object.values(ungroupedEmployees).map((e) => {
        if (!formState.includes(e.id)) return null;

        return (
          <EmployeeRow key={e.id} employee={e} handleRemove={handleSelect} />
        );
      })}

      {showLoadMore() ? (
        <button
          type="button"
          className="flex flex-align-center btn-clear btn-link m-l-4 m-r-40"
          onClick={onLoadMore}
        >
          <span className="m-r-8">Load More</span>
          <TriangleBlueIcon
            style={{ height: '20px' }}
            transform="rotate(180)"
          />
        </button>
      ) : null}
    </React.Fragment>
  );
};

export default ManageParticipantsForm;
